export const ClientBookingServicesPage = {
  en: {
    'Select service': 'Select service',
    // SS-1225 (temporary)
    'Location temporarily unavailable message':
      'Climbing SPACE is temporarily unavailable, you can book at our other locations in Kyiv',
  },
  uk: {
    'Select service': 'Оберіть послугу',
    // SS-1225 (temporary)
    'Location temporarily unavailable message':
      'Climbing SPACE тимчасово недоступний, ви можете записатися на інші наші локації в Києві',
  },
};
